import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBankSlip, showImageStore } from "../../features/cartSlice";
import { setImage } from "../../features/userDetailsSlice";
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { useParams } from "react-router-dom";
import PropTypes from 'prop-types';

const App = ({ imageType = 'bankSlip' }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();
  const useParam = useParams();
  const bankSlips = useSelector((state) => state.cartDetails?.showImageStore);
  const isBankSlip = imageType === 'bankSlip';

  const userId = useParam.loggedUId;
  const onFilesChange = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles(files);

    if (isBankSlip) {
      files.forEach(file => {
        // Just update metadata and preview for now, do NOT upload
        dispatch(setBankSlip({ slip_name: file.name, date: file.lastModifiedDate, file: file }));
        dispatch(showImageStore({ slip_name: file.name, date: file.lastModifiedDate, url: URL.createObjectURL(file) }));
      });
    } else {
      // Limit to 5 images
      const limitedFiles = files.slice(0, 5);
      if (files.length > 5) {
        alert("You can only upload up to 5 profile images.");
      }

      const imagesPayload = limitedFiles.map(file => ({
        image_name: file.name,
        date: file.lastModifiedDate,
        url: URL.createObjectURL(file),
        file: file
      }));

      dispatch(setImage(imagesPayload));
    }
  };

  const onFileRemove = (fileName) => {
    // Clear the physical input so the same file can be re-selected if needed
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    setSelectedFiles([]);

    if (isBankSlip) {
      dispatch(showImageStore("clear"));
      dispatch(setBankSlip({ slip_name: '', date: '' }));
    } else {
      dispatch(setImage([]));
    }
  };

  return (
    <div>
      <div>
        <input
          type="file"
          ref={fileInputRef}
          name={isBankSlip ? "slip_name" : "profile_image"}
          onChange={onFilesChange}
          multiple={true}
          accept="image/*"
        />
      </div>
      <div>
        <h3>{isBankSlip ? 'Uploaded Bank Slips' : 'Uploaded Profile Image'}</h3>
        {isBankSlip && bankSlips && bankSlips.length > 0 && (
          <ImageList sx={{ width: 500, height: 150 }} cols={4} rowHeight={154}>
            {bankSlips.map((file, index) => (
              <ImageListItem key={index}>
                {file.slip_name} - {new Date(file.date).toDateString()}
                <img src={file.url} alt={file.slip_name} />
                <button onClick={() => onFileRemove(file.slip_name)}>Remove</button>
              </ImageListItem>
            ))}
          </ImageList>
        )}
      </div>
    </div>
  );
};

App.propTypes = {
  imageType: PropTypes.oneOf(['bankSlip', 'profileImage']),
};

export default App;
